var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDigital(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    stroke: "#00BCD4",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0833 22.8835L22.9083 24.0585L20.2167 21.4168L19.3333 23.4752L17.6667 17.6668L23.5 19.3335L21.3917 20.1918L24.0833 22.8835ZM21.8333 12.6668H10.1667V21.8335H17.175L17.6417 23.5002H10.1667C9.72464 23.5002 9.30072 23.3246 8.98816 23.012C8.67559 22.6994 8.5 22.2755 8.5 21.8335V10.1668C8.5 9.7248 8.67559 9.30088 8.98816 8.98832C9.30072 8.67576 9.72464 8.50016 10.1667 8.50016H11V6.8335H12.6667V8.50016H19.3333V6.8335H21V8.50016H21.8333C22.75 8.50016 23.5 9.25016 23.5 10.1668V17.6252L21.8333 17.1252V12.6668ZM16 14.3335V18.5002H11.8333V14.3335H16Z",
    fill: "#00BCD4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigital);
export default __webpack_public_path__ + "static/media/digital.e582260726cafdc920e8ba4cc0bb45f2.svg";
export { ForwardRef as ReactComponent };